import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../Auth/AuthContext';
import { signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { auth } from '../firebase';
import '../css/AppMenu.css';

function AppMenu() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate('/'); // Redirect to home page after sign out
  };

  const signInWithGoogle = (e) => {
    e.preventDefault();
    const provider = new GoogleAuthProvider();
    signInWithPopup(auth, provider)
      .then(() => {
        navigate('/dashboard');
      })
      .catch((error) => {
        console.error("Error signing in with Google:", error);
      });
  };
  
  return (
    <div className="menu-header">
      <h1 className="title">TurboSME Solutions</h1>
      <nav className="app-menu">
        <ul>
          <li><Link to="/">Home</Link></li>
          {user ? (
            <>
              <li><Link to="/GetPrintQuote">Get Print Quote</Link></li>
              <li><Link to="/dashboard">Dashboard</Link></li>
              <li><a href="#" onClick={handleSignOut}>Sign Out</a></li>
            </>
          ) : (
            <li>
              <a href="#" onClick={signInWithGoogle} className="google-signin">
                <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google logo" className="google-icon" />
                Login
              </a>
            </li>
          )}
        </ul>
      </nav>
    </div>
  );
}

export default AppMenu;
